// removed by extract-text-webpack-plugin
module.exports = {"button":"src-components-Button----Button-module---button---2X_Ir","edit":"src-components-Button----Button-module---edit---3JnDV","alt":"src-components-Button----Button-module---alt---21PR6","confirm":"src-components-Button----Button-module---confirm---3WGNm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.module.scss
// module id = 1170
// module chunks = 168707334958949